import { render, staticRenderFns } from "./PlusCircleIcon.vue?vue&type=template&id=855dad20"
import script from "./PlusCircleIcon.vue?vue&type=script&lang=js"
export * from "./PlusCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports